import Vue from 'vue';
import Vuex from 'vuex';
import CommonForms from './module/commonForms';
import Calculation from './module/calculation';
import OtherPages from './module/otherPages';
import CapitalAccount from './module/capitalAccount';
import PublicPage from './module/publicPage';

Vue.use(Vuex);

export default new Vuex.Store({
  // 全局的状态
  state: {
    // 推荐人手机号
    phone: '',
    // orderid
    orderId: localStorage.getItem('pinganOrderId'),
    // 借款用途
    columnsIntend: [
      { text: '生产经营', value: '1' },
    ],
    userId: localStorage.getItem('userId'),
    // 通用外部变量 从detail或者本地存储获取的变量值
    corpId: localStorage.getItem('corpId'), // 企业ID
    // 渠道信息
    channelId: '', // 渠道ID
    channelUserId: '', // 渠道用户ID

    pinganFormMap: {
      moneyDemandPlaceHolder: '1-50(万元）',
    },
  },
  mutations: {
    updatePhone(state, value) {
      console.log('value', value);
      state.phone = value.phone;
    },
    updateOrderId(state, value) {
      state.orderId = value;
    },
  },
  actions: {
  },
  modules: {
    commonForms: CommonForms,
    calculation: Calculation,
    otherPages: OtherPages,
    capitalAccount: CapitalAccount,
    publicPage: PublicPage,
  },
});
